/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_AllInputs */

const en_cad_learn_all = /** @type {(inputs: Cad_Learn_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all tutorials`)
};

/**
* | output |
* | --- |
* | "See all tutorials" |
*
* @param {Cad_Learn_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_all = /** @type {((inputs?: Cad_Learn_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_all(inputs)
});
export { cad_learn_all as "cad.learn.all" }